import { array } from 'fp-ts';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useAccountingCategories = (enterpriseIds: string[]) =>
    useRepositoryQuery(
        'accountingCategories',
        'getAll',
        { enterpriseIds },
        {
            enabled: array.isNonEmpty(enterpriseIds),
        }
    );
